export class MeshLoader {
}
